// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"campaigns_scrollbar__2pQjf"};